export default {

    checkVisible: function(subQuestion, mainAnswer, mainQuestion, tradePoint) {
        if (!this.isAnswered(mainAnswer, mainQuestion))
            return false;
        
        if (subQuestion.SubVisiblePoliticList.length == 0)
            return true;

        //Отображать если
        var isShow = subQuestion.SubVisiblePoliticList[0].VisibleCondition === 1;
        
        //Проходим по всем политикам видимости подвопроса
        for (var i = 0; i < subQuestion.SubVisiblePoliticList.length; i++) {
            var vp = subQuestion.SubVisiblePoliticList[i];
            
            //Если политика от ответа на вопрос
            if (vp.RelationType === 1)
            {
                var parentQuestionId = vp.ParentQuestionId;

                var parentQuestion = mainQuestion.QuestionId == parentQuestionId
                    ? mainQuestion
                    : mainAnswer.SubQuestionList.find(q => q.QuestionId == parentQuestionId);
                
                if (parentQuestion == null)
                    continue;

                if (parentQuestion.IsVisible == false)
                    continue;

                //Берем ответы на вопрос от которого зависит политика
                var parentAnswers = parentQuestion == mainQuestion
                    
                    ? [ mainAnswer ]
                    : parentQuestion.AnswerList;
                
                //Вопрос с вариантами выбора?
                var isMultipleAnswer = parentQuestion.IsAep || 
                                       parentQuestion.IsMultipleSelect || 
                                       parentQuestion.IsSelect || 
                                       parentQuestion.IsSmallSelect;
                
                //Политика зависит от ответа на текущий вопрос?
                var isMain = parentQuestion === mainQuestion;

                //Политика выполняется?
                var checked = isMultipleAnswer
                    ? this.multiQuestionPolicyChecked(vp, parentQuestion, parentAnswers, isMain)
                    : this.singleQuestionPolicyChecked(vp, parentQuestion, parentAnswers[0], isMain);
                    
                if (!checked) return !isShow;
            }

            //Если политика от торговой точки
            else if (vp.RelationType === 2) {
                var checked = this.tradePointPolicyChecked(vp, tradePoint);
                if (!checked) return !isShow;
            }
        }

        return isShow;
    },

    tradePointPolicyChecked: function(vp, tradePoint) {

        switch (vp.ConditionType) {

            //Тт является сетью?
            case 200:
                return vp.Value
                    ? tradePoint.MdRetailChainId == "Сеть"
                    : tradePoint.MdRetailChainId == "Не сеть";
            
            //У торговой точки указанный тип
            case 201:
                return tradePoint.SubType == vp.Value;

            //Торговая точка находится в филиале
            case 202:
                return tradePoint.Branch == vp.Value;
                
            //Торговая точка относится к сети
            case 203:
                return vp.Value.some(a => a == tradePoint.RetailChainCode);
                
            //Торговая точка не относится к сети
            case 204:
                return !vp.Value.some(a => a == tradePoint.RetailChainCode);

            //Торговая точка содержит ТМА
            case 205:
                return tradePoint.Tma != null;

            //Торговая точка находится в регионе
            case 206:
                return vp.Value.some(a => a == tradePoint.Region);
        }


    },

    
    isAnswered: function (answer, question) {

        //Если тип вопроса связан с выбором из списка - смотрим Selected
        if (question.IsSelect || 
            question.IsMultipleSelect || 
            question.IsAep || 
            question.IsSmallSelect)
            {
                return answer.Selected != null;
            }
        
        //Если любой другой - смотрим Value
        return answer.Value != null && answer != undefined;
    },

    multiQuestionPolicyChecked: function(vp, parentQuestion, parentAnswers, isMain) {

        switch (vp.ConditionType) {

            //Ответ выбран
            case 20:
                var answerForCheck = parentAnswers.find(a => a.Value.Key == vp.Value);
                if (answerForCheck == undefined)
                    return false;

                return answerForCheck.Selected == true; 
            //Ответ не выбран
            case 21:
                var answerForCheck = parentAnswers.find(a => a.Value.Key == vp.Value);
                if (answerForCheck == undefined)
                    return false;

                return answerForCheck.Selected == false;
                
            //AEP/SKU выбран
            case 100:
                if (!isMain)
                    return false;
                
                return parentAnswers[0].Selected == true;
                
            //AEP/SKU не выбран
            case 101:
                if (!isMain)
                    return false; 

                return parentAnswers[0].Selected == false;                
        }

    },

    singleQuestionPolicyChecked: function(vp, parentQuestion, answer, isMain) {

        switch (vp.ConditionType) {
            
            //Любой текст
            case 1:
                return Boolean(answer.Value);

            //Текст совпадает с
            case 2:
                return vp.Value.toLowerCase() == answer.Value.toLowerCase();
                
            //Число равно
            case 10:
                return Number(answer.Value) == Number(vp.Value);
                
            //Число больше
            case 11:
                return Number(answer.Value) > Number(vp.Value);
                
            //Число меньше
            case 12:
                return Number(answer.Value) < Number(vp.Value);
                
            //Контакт выбран
            case 30:
                return Boolean(answer.Value);
                
            //Выбрано да
            case 40:
                return answer.Value == true;
                
            //Выбрано нет
            case 41:
                return answer.Value == false;

        }

    },

    clearAnswers: function(answerType, answers) {

    }

}